import { HHAlert, HHTypography } from '@hinge-health/react-component-library';

type DrawerMode =
  | 'archive'
  | 'void'
  | 'release'
  | 'check-eligibility'
  | 'update-netsuite-id'
  | 'create-manual-hold'
  | 'process-copayment'
  | 'update-billing-type';

type AlertConfig = {
  severity: 'warning' | 'error';
  title: string;
  heading: string;
  message: string;
};

const ALERT_CONFIGS: Record<DrawerMode, AlertConfig> = {
  archive: {
    severity: 'warning',
    title: 'Archive Bill',
    heading: 'Archiving bills',
    message: 'Review carefully, archived bills will be set as non-billable',
  },
  void: {
    severity: 'warning',
    title: 'Void Submissions',
    heading: 'Voiding submissions',
    message: 'Review carefully before voiding submissions',
  },
  'check-eligibility': {
    severity: 'warning',
    title: 'Recheck Eligibility',
    heading: 'Rechecking eligibility',
    message: 'When rechecking eligibility please select deep or shallow',
  },
  'update-netsuite-id': {
    severity: 'warning',
    title: 'Update Netsuite ID',
    heading: 'Updating Netsuite ID',
    message: 'Please confirm the Netsuite ID is valid and exists in Netsuite',
  },
  'create-manual-hold': {
    severity: 'warning',
    title: 'Create Manual Hold',
    heading: 'Create a manual hold',
    message: 'Review carefully before creating a manual hold',
  },
  'process-copayment': {
    severity: 'warning',
    title: 'Process Copayment',
    heading: 'Processing copayment',
    message:
      'Review carefully. Only eligible bills (submitted with awaiting remit status) will be processed.',
  },
  release: {
    severity: 'warning',
    title: 'Release Bill',
    heading: 'Review bills to be released',
    message:
      'When released the bills will be submitted in the next round of submissions, if client or carrier change, please select a client insurer to release the bill',
  },
  'update-billing-type': {
    severity: 'warning',
    title: 'Update Billing Type',
    heading: 'Updating billing type',
    message:
      'Review carefully. The billing type will be updated on the active contract for each selected client insurer.',
  },
};

export interface PanelAlertProps {
  drawerMode: DrawerMode;
  hasSameHoldType?: boolean;
  clientInsurerChangesMatch?: boolean;
}

export const PanelAlert = ({
  drawerMode,
  hasSameHoldType,
  clientInsurerChangesMatch,
}: PanelAlertProps): JSX.Element => {
  const { severity, title, heading, message } = ALERT_CONFIGS[drawerMode];

  if (drawerMode === 'release') {
    if (hasSameHoldType === false) {
      return (
        <HHAlert severity="error" title="Hold Types" hhVariant="filled">
          <HHTypography variant="h4" hhVariant="h4">
            Hold types do not match
          </HHTypography>
          You can only release bills with the same hold type
        </HHAlert>
      );
    }
    if (clientInsurerChangesMatch === false) {
      return (
        <HHAlert
          severity="error"
          title="Client/Insurer Change"
          hhVariant="filled"
        >
          <HHTypography variant="h4" hhVariant="h4">
            Unable to release
          </HHTypography>
          Client Insurer change does not match
        </HHAlert>
      );
    }
  }

  return (
    <HHAlert severity={severity} title={title} hhVariant="outlined">
      <HHTypography variant="h4" hhVariant="h4">
        {heading}
      </HHTypography>
      {message}
    </HHAlert>
  );
};
